import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-emerald-950 text-emerald-100 pt-16 pb-12 border-t border-emerald-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-12 mb-12">
          
          {/* Col 1: Brand & Intro */}
          <div className="space-y-4">
            <div className="flex flex-col">
              <span className="font-black text-2xl tracking-tight text-white">
                Power<span className="text-emerald-400">-</span>Multiservice
              </span>
              <span className="text-[11px] font-semibold text-white/80 uppercase tracking-widest -mt-0.5">
                Kvalitetsrengøring
              </span>
            </div>
          </div>

          {/* Col 2: Services Navigation */}
          <div>
            <h3 className="text-base font-bold text-white mb-4">
              Ydelser
            </h3>
            <ul className="space-y-2.5 text-sm text-white">
              <li>
                <Link
                  to="/privat-rengoering"
                  className="hover:underline transition-colors flex items-center gap-2 group text-white"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/70 group-hover:text-white transition-colors" aria-hidden="true" />
                  Privat rengøring
                </Link>
              </li>
              <li>
                <Link
                  to="/erhvervsrengoering"
                  className="hover:underline transition-colors flex items-center gap-2 group text-white"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/70 group-hover:text-white transition-colors" aria-hidden="true" />
                  Erhvervsrengøring
                </Link>
              </li>
              <li>
                <Link
                  to="/prisberegner"
                  className="hover:underline transition-colors flex items-center gap-2 group text-white font-semibold"
                >
                  <i className="fa-solid fa-calculator text-xs text-white" aria-hidden="true" />
                  Online prisberegner
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 3: Sider Navigation */}
          <div>
            <h3 className="text-base font-bold text-white mb-4">
              Genveje
            </h3>
            <ul className="space-y-2.5 text-sm text-white">
              <li>
                <Link
                  to="/"
                  className="hover:underline transition-colors flex items-center gap-2 group text-white"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/70 group-hover:text-white transition-colors" aria-hidden="true" />
                  Forside
                </Link>
              </li>
              <li>
                <Link
                  to="/om-os"
                  className="hover:underline transition-colors flex items-center gap-2 group text-white"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/70 group-hover:text-white transition-colors" aria-hidden="true" />
                  Om Power-Multiservice
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  className="hover:underline transition-colors flex items-center gap-2 group text-white"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/70 group-hover:text-white transition-colors" aria-hidden="true" />
                  Kontakt os
                </Link>
              </li>
              <li>
                <Link
                  to="/prisberegner"
                  className="hover:underline transition-colors flex items-center gap-2 group text-white"
                >
                  <i className="fa-solid fa-chevron-right text-[10px] text-white/70 group-hover:text-white transition-colors" aria-hidden="true" />
                  Få et tilbud
                </Link>
              </li>
            </ul>
          </div>

          {/* Col 4: Virksomhedsoplysninger (Unbreakable email & phone) */}
          <div>
            <h3 className="text-base font-bold text-white mb-4">
              Kontaktinformation
            </h3>
            <div className="space-y-3.5 text-sm text-white">
              <div className="flex items-start gap-3">
                <i className="fa-solid fa-location-dot text-sm text-white shrink-0 mt-1" aria-hidden="true" />
                <div>
                  <p className="font-semibold text-white">Power-Multiservice</p>
                  <p className="text-white/90">Idrætsvej 1</p>
                  <p className="text-white/90">5580 Nørre Aaby</p>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-phone text-sm text-white shrink-0" aria-hidden="true" />
                <div>
                  <span className="text-xs text-white/80 block">Telefon</span>
                  <a
                    href="tel:31686764"
                    className="font-bold text-white hover:underline transition-colors whitespace-nowrap"
                    aria-label="Ring 31 68 67 64"
                  >
                    31 68 67 64
                  </a>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <i className="fa-solid fa-envelope text-sm text-white shrink-0" aria-hidden="true" />
                <div>
                  <span className="text-xs text-white/80 block">Email</span>
                  <a
                    href="mailto:zokimaretic@gmail.com"
                    className="text-white hover:underline transition-colors whitespace-nowrap font-medium"
                    aria-label="Send email til zokimaretic@gmail.com"
                  >
                    zokimaretic@gmail.com
                  </a>
                </div>
              </div>
            </div>
          </div>

        </div>

        {/* Bottom Bar */}
        <div className="pt-8 border-t border-emerald-900/80 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-white/80">
          <p>© {currentYear} Power-Multiservice · CVR: 27253466 · Alle rettigheder forbeholdes.</p>
          <p className="flex items-center gap-1.5 text-white/80">
            <span>Professionel rengøring i Nørre Aaby og omegn</span>
          </p>
        </div>
      </div>
    </footer>
  );
}
